var React = require('react');
var moment = require('moment');
var _ = require('lodash');
var cx = require('classnames');
import { connect } from 'react-redux';
import { dayMouseOverAndCalculate, dayClickAndCalculate } from './actions';
import Translator from "bazinga-translator";

/**
 * Responsible for rendering a day
 */
class Day extends React.Component {
    constructor(props, context) {
        super(props, context);
    }
        
    handleClick() { 
        if(this.props.static && !this.props.interactive){
            return;
        }
        this.props.dispatch(dayClickAndCalculate(this.props.day));
    }

    handleMouseOver() { 
        if(this.props.static && !this.props.interactive){ 
            return;
        }
        
        if(cvtemplating.calendar_update_hover){ 
            this.props.dispatch(dayMouseOverAndCalculate(this.props.day));
        } else {
            
        }
    }

    isAvailable() {
        var day = this.props.day;
        if (_.find(this.props.ranges.availability, (range) => {
            return day.isSameOrAfter(range.start) && day.isSameOrBefore(range.end);
        })) {
            return true;
        }
        return false;
    }

    getStateInRanges(day, ranges) { 
        if (_.find(ranges, (range) => {
            return day.isAfter(range.start) && day.isSameOrBefore(range.end);
        })) {
            return 'middle';
        }

        if (_.find(ranges, (range) => {
            return day.isSame(range.start);
        })) {
            return 'start';
        }

        if (_.find(ranges, (range) => {
            return day.clone().subtract(1, 'day').isSame(range.end);
        })) {
            return 'end';
        }

        return 'unavailable';
    }

    getPrice() {

        // if not available, no price
        if (!this.isAvailable()) {
            return;
        }

        var range = _.find(this.props.ranges.pricing[this.props.lengthOfStay], (range) => {
            return this.props.day.isSameOrAfter(range.start) && this.props.day.isSameOrBefore(range.end);
        });
        
        if (!range) {
            return;
        }
        if (range.discountEndsAt === null) {
            return;
        }
        if (range) {
            if (range.priceWithDiscount < range.price) {
                var price = Math.ceil((range.price - range.priceWithDiscount) / range.price * 100);
                const title = Translator.trans('discount', {}, 'messages');
                return (<div className="day-price discount" title={title} >- % </div>);
            }
            return;
        }
    }

    getSlashthrough() {
        return;
        // if not available, no price
        if (!this.isAvailable()) {
            return;
        }

        var range = _.find(this.props.ranges.pricing, (range) => {
            return this.props.day.isSameOrAfter(range.start) && this.props.day.isSameOrBefore(range.end);
        });
        if (range && range.priceWithDiscount) {
            return (<div className="slashthrough">&euro;{parseInt(range.price)}</div>);
        }
    }

    getClassAvailability() {
        switch (this.getStateInRanges(this.props.day, this.props.ranges.availability)) {
            case 'start':
                return 'start-day';
            case 'end':
                return 'end-day';
            case 'unavailable':
                return 'unavailable';
            case 'single':
            case 'middle':
                break;
        }
    }

    getClassSelecting() {
        var day = this.props.day;
        var start = this.props.refresh.start ? this.props.refresh.start : this.props.firstPeriodStart;
        var end = this.props.refresh.end ? this.props.refresh.end : this.props.firstPeriodEnd;
        var inEdit = this.props.inEdit;

        if (inEdit) {
          if (day.isAfter(start) && day.isSameOrBefore(end)) {
              return ['selecting', 'selecting-middle'];
          }
          if (day.isSame(start)) {
              return ['selecting', 'selecting-start'];
          }
          if (day.clone().subtract(1, 'day').isSame(end)) {
              return ['selecting', 'selecting-end'];
          }
       }
    }

    getClassSelected() {
        var day = this.props.day;
        var start = this.props.refresh.start ? this.props.refresh.start : this.props.firstPeriodStart;
        var end = this.props.refresh.end ? this.props.refresh.end : this.props.firstPeriodEnd;
        
        if (day.isAfter(start) && day.isSameOrBefore(end)) {
            return ['selected', 'selected-middle'];
        }
        if (day.isSame(start)) {
            return ['selected', 'selected-start'];
        }
        if (day.clone().subtract(1, 'day').isSame(end)) {
            return ['selected', 'selected-end'];
        }
    }

    getClassArrivalAllowed() {
        var pricingRange = _.find(this.props.ranges.pricing[this.props.lengthOfStay], (range) => {
            return this.props.day.isSameOrAfter(range.start) && this.props.day.isSameOrBefore(range.end);
        });
        var availabilityRange = _.find(this.props.ranges.availability, (range) => {
            return this.props.day.isSameOrAfter(range.start) && this.props.day.isSameOrBefore(range.end);
        });
        if (pricingRange && pricingRange.arrivalDays.indexOf(this.props.day.day()) == -1) {
            return 'arrival-forbidden';
        }
        if (pricingRange && availabilityRange) {
            if (availabilityRange.end.diff(this.props.day, 'days') + 1 < pricingRange.minimalStay) {
                return 'arrival-forbidden';
            }
        }
    }
    getClassDepartureAllowed() {
        var inEdit = this.props.inEdit;
        var start = this.props.refresh.start ? this.props.refresh.start : this.props.firstPeriodStart;
        var pricingRange = _.find(this.props.ranges.pricing[this.props.lengthOfStay], (range) => {
            return this.props.day.isSameOrAfter(range.start) && this.props.day.isSameOrBefore(range.end);
        });
        var availabilityRange = _.find(this.props.ranges.availability, (range) => {
            return this.props.day.isSameOrAfter(range.start) && this.props.day.isSameOrBefore(range.end);
        });
        if (pricingRange && pricingRange.arrivalDays.indexOf(this.props.day.day()) > -1 && inEdit && this.props.day.isSameOrAfter(start)) {
            return 'departure-allowed';
        }
        if (pricingRange && availabilityRange ) {
            if (availabilityRange.start.diff(this.props.day, 'days') >= pricingRange.minimalStay && inEdit && this.props.day.isSameOrAfter(start)) {
                return 'departure-allowed';
            }
        }
        if (this.getClassAvailability() == 'end-day' && inEdit) {
            return 'departure-allowed';
        }
    }
    getAvailableBar() {
        if ( this.getClassArrivalAllowed() !== 'arrival-forbidden' && this.getClassAvailability() !== 'unavailable' && this.getClassAvailability() !== 'end-day' ) {
            var start = _.find(this.getClassSelected() , (cls) => {
                return (cls === 'selected-start');
            });
            var end = _.find(this.getClassSelected() , (cls) => {
                return (cls === 'selected-end');
            });

            if (start) {
                var startClass = 'start';
            }
            if (end ) {
                var endClass = 'end';
            }

            return (
                <div className={cx('available-bar', startClass, endClass )}></div>
            );
        }
        return ( <div className={cx('unavailable-bar', startClass, endClass )}></div> );
    }

    render() {
        var classAvailability = this.getClassAvailability();
        var classSelected = this.getClassSelected();
        var classSelecting = this.getClassSelecting();
        var classArrivalAllowed = this.getClassArrivalAllowed();
        var classDepartureAllowed = this.getClassDepartureAllowed();
        var availableBar = this.getAvailableBar();

        return (
            <td key={'td'+this.props.day.format('DDMMYYYY')} className={cx('day', classAvailability, classSelected, classSelecting, classArrivalAllowed, classDepartureAllowed) + (this.props.static && !this.props.interactive ? ' static':'')} onMouseOver={this.handleMouseOver.bind(this)} onClick={this.handleClick.bind(this)}>
                <div className="day-content" key={'dc'+this.props.day.format('DDMMYYYY')}>{this.props.day.format('D')}</div>
                {this.getSlashthrough()}
                {this.getPrice()}
            </td>
            );
    
    //{this.getAvailableBar()}
    }
}

const mapStateToProps = (state) => (
    {
    lengthOfStay: state.calendarStore.lengthOfStay,
    ranges: state.calendarStore.ranges,
    inEdit: state.calendarStore.inEdit,
    firstPeriodStart: state.calendarStore.firstPeriodStart,
    firstPeriodEnd: state.calendarStore.firstPeriodEnd
});

export default connect(mapStateToProps)(Day);
